import './styles.scss'
import React from 'react'
import { I18n } from 'react-redux-i18n'
import _get from 'lodash.get'

import { SelectCountry } from 'components/Chat/Plugins/commons'
import FileUploader from './FileUploader'
import MsgWithOptions from './MsgWithOptions'
import ColorPicker from './ColorPicker'
import ScheduleButton from './ScheduleButton'
import AuthenticationType from './AuthenticationType'
import SendConnectionAPIToken from './SendConnectionAPIToken'
import Switch from './Switch'
import Select from './Select'
import SelectChannelRedirect from './SelectChannelRedirect'
import InputText from './InputText'
import InputTextArea from './InputTextArea'
import FacebookButton from './FacebookButton'
import IsActiveNauta from './IsActiveNauta'
import Signature from './Signature'
import AddAccount from './AddAccount'
import WhatsappValidationButton from './WhatsappValidationButton'
import TimerSelector from 'components/common/TimerSelector'
import TimeAndDate from 'utils/TimeAndDate'

/**
 * Check field is disabled
 * @param {string} key
 * @param {boolean} isActive
 * @param {boolean} disabled
 * @param {boolean} readonlyIsActive
 * @returns {boolean}
 */
function isDisabledChannel(key, isActive, disabled, readonlyIsActive) {
  if (['android', 'ios'].includes(key)) return false
  if (readonlyIsActive === false) return false

  return isActive || disabled
}

/**
 * Render fields
 * @param {object} props
 * @param {object} props.configInput field schema
 * @param {object} props.channel current channel info
 * @param {boolean} [props.disabled=false]
 * @param {function} props.onChangeChannel Update channel
 * @param {boolean} props.error
 * @param {object} props.company
 */
const renderField = (props) => {
  const { configInput, channel, disabled = false, onChangeChannel, error, isOpenContainer, onSubmit, schema, onOTPVerification } = props
  const { field, prop, propName, defaultValue, limit, readonlyIsActive, hidden } = configInput

  const onChange = (value, _prop = prop) => {
    onChangeChannel(_prop, value)
  }

  let value = _get(channel, prop)
  if (value === undefined && defaultValue && field !== 'image') {
    value = typeof defaultValue === 'string' ? I18n.t(defaultValue) : defaultValue
  }
  if (field === 'richText' && (!value?.content || !value?.contentHtml)) {
    if (!value?.content?.length && value?.contentHtml !== '<p><br></p>') {
      if (defaultValue) {
        value = { contentHtml: typeof defaultValue === 'string' ? I18n.t(defaultValue) : defaultValue }
      }
      // Valor por defecto para el campo authMsg
      else if (prop === 'value.authMsg') {
        if (_get(channel, `value.authenticationType`) === 'only_phone' || _get(channel, `value.authenticationType`) === 'sms') {
          value = { content: I18n.t('credentials_authMsg_default_phone'), contentHtml: I18n.t('credentials_authMsg_default_phone') }
        } else if (_get(channel, `value.authenticationType`) === 'only_email' || _get(channel, `value.authenticationType`) === 'email') {
          value = { content: I18n.t('credentials_authMsg_default_email'), contentHtml: I18n.t('credentials_authMsg_default_email') }
        }
      }
    }
  }

  const channelDisabled = isDisabledChannel(channel.key, channel.isActive, disabled, readonlyIsActive)
  const id = `${channel._id}_${channel.key}_${channel.hub}_${propName}`

  let _hidden = false
  if (prop === 'value.closeMsg' && !_get(channel, `value.withCloseMsg`)) _hidden = true
  if (channel.key === 'chatweb' && (prop === 'value.authMsg' || prop === 'value.authOkMsg')) {
    if (
      !_get(channel, `value.authenticationType`)
      || _get(channel, `value.authenticationType`) === 'none'
      || _get(channel, `value.authenticationType`) === 'redirectFromChannel'
    ) _hidden = true
  }

  if (hidden || _hidden) return null

  switch (field) {
    case 'switch':
      return (
        <Switch
          id={id}
          defaultChecked={value || false}
          onChange={onChange}
          disabled={disabled}
          {...configInput}
        />
      )
    case 'select':
      return (
        <Select
          id={id}
          value={value || ''}
          onChange={onChange}
          invalid={error}
          disabled={channelDisabled}
          {...configInput}
        />
      )
    case 'text':
      return (
        <InputText
          id={id}
          maxLength={limit || ''}
          value={value || ''}
          onChange={onChange}
          disabled={channelDisabled}
          invalid={error}
          {...configInput}
        />
      )
    case 'textarea':
      return (
        <InputTextArea
          value={value || ''}
          onChange={onChange}
          height='large'
          maxLength={limit || ''}
          {...configInput}
        />
      )
    case 'image':
    case 'video':
      return (
        <FileUploader
          channel={channel}
          disabled={channelDisabled}
          onChange={onChange}
          value={value || ''}
          primaryColor={channel.value.primaryColor || ''}
          isOpenContainer={isOpenContainer}
          {...configInput}
        />
      )
    case 'onlyRead':
      if (!value) return null
      return (
        <InputText
          id={id}
          maxLength={limit || ''}
          value={value || ''}
          onChange={onChange}
          disabled
          {...configInput}
        />
      )
    case 'selectCountry':
      return <SelectCountry name={propName} value={value || ''} onChange={onChange} disabled={channelDisabled} error={error} />
    case 'richText':
      return (
        <MsgWithOptions
          id={id}
          value={value || {}}
          onChange={onChange}
          channel={channel.key !== 'wall'
            ? channel.key
            : _get(channel, `value.connectionType`) === 'ios_api'
              ? 'ios'
              : _get(channel, `value.connectionType`) === 'android_api'
                ? 'android'
                : 'chatweb'
          }
          {...configInput}
        />
      )
    case 'colorPicker':
      return (
        <ColorPicker
          id={id}
          value={value || defaultValue || ''}
          onChange={onChange}
          disabled={channelDisabled}
          error={error}
          {...configInput}
        />
      )
    case 'schedule':
      return (
        <ScheduleButton
          prop={prop}
          value={value}
          onChange={onChange}
          {...configInput}
        />
      )
    case 'authenticationType':
      return <AuthenticationType
        value={value || {}}
        onChange={onChange}
        error={error} {...props}
        channel={channel}
        {...configInput}
      />
    case 'sendAPIToken':
      return (
        <SendConnectionAPIToken
          channel={channel}
          config={configInput}
          {...configInput}
        />
      )
    case 'facebookButton':
      return (
        <FacebookButton
          prop={prop}
          value={value}
          onChange={onChangeChannel}
          channel={channel}
          disabled={disabled}
          // typeChannel={typeChannel}
          {...configInput}
        />
      )
    case 'isActiveNauta':
      return (
        <IsActiveNauta
          prop={prop}
          value={value}
          scheduleNauta={_get(channel, `scheduleNauta`)}
          onChange={onChange}
          {...configInput}
        />
      )
    case 'addAccountButton':
      return (
        <AddAccount
          prop={prop}
          value={value}
          onChange={onChange}
          onSubmit={onSubmit}
          schema={schema}
          channel={channel}
          {...configInput}
        />
      )
    case 'signature':
      return (
        <Signature
          prop={prop}
          value={value || ''}
          onChange={onChange}
          {...configInput}
        />
      )
    case 'validateWhatsappButton':
      return (
        <WhatsappValidationButton
          prop={prop}
          value={value || ''}
          channel={channel}
          onChange={onChange}
          onOTPVerification={onOTPVerification}
          onSubmit={onSubmit}
          {...configInput}
        />
      )
    case 'number':
      return (
        <InputText
          type='number'
          id={id}
          value={value || ''}
          onChange={onChange}
          disabled={channelDisabled}
          invalid={error}
          min={0}
          className='channel_input_number'
          {...configInput}
        />
      )
    case 'timeSelector': {
      const valuesTimer = TimeAndDate.millisecondsToUnit({
        time: value?.time || 0,
        unit: value?.unit?.trim() || 'minutes'
      })

      return (
        <TimerSelector
          label={I18n.t(configInput.label)}
          value={valuesTimer}
          onChange={value => {
            onChange(
              TimeAndDate.timeToMilliseconds({
                unit: value.unit, time: value.time
              })
            )
          }}
          includes={configInput?.options || []}
        />
      )
    }
    case 'selectChannelRedirect' : 
      return (
        <SelectChannelRedirect
          id={id}
          value={value || ''}
          onChange={onChange}
          invalid={error}
          disabled={channelDisabled}
          {...configInput}
        />
      )
    default:
      return null
  }
}

export default renderField